import React, { Component } from 'react';
import { Data } from '../Data';

export class Login extends Component {
    constructor(props) {
        super(props);
        this.dataService = new Data();
        this.tryLogin = this.tryLogin.bind(this);
        this.getIdentity = this.getIdentity.bind(this);

        this.state = {
            username: '',
            password: '',
            submitted: false,
            message1: '', 
            message2: ''
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    tryLogin(e) {
        e.preventDefault();
        this.setState({ submitted: true, errorMessage: null });
        const { username, password } = this.state;
        if (username && password) {
            this.dataService.tryLogin(username, password)
                .catch((errormsg) => {
                    const text = errormsg.message;
                    this.setState({
                        message1: text
                    });
                    console.error(text);
                });
        }
    }

    getIdentity() {
        this.dataService.getIdentity();
    }

    render() {
        const { username, password, submitted } = this.state;
        return (
            <div>
                <h3>Phoenix Sign In</h3>
                <form name="form" onSubmit={this.tryLogin}>
                    <div className='login-form-container'>
                        <label className='login-form-label'>USERNAME</label>
                        <input
                            type="text"
                            className={'form-control' + (submitted && !username ? ' has-error' : '') + ' login-form-text'}
                            name="username"
                            onChange={this.handleChange}
                            title="User name text box" />
                        {submitted && !username &&
                            <div className="help-block">Username is required</div>
                        }

                        <label className='login-form-label'>PASSWORD</label>
                        <input
                            type="password"
                            className={"form-control" + (submitted && !password ? ' has-error' : '') + ' login-form-text'}
                            name="password"
                            onChange={this.handleChange}
                            title="Password text box"
                        />
                        {submitted && !password &&
                            <div className="help-block">Password is required</div>
                        }

                        {this.state.message1 && <div className='help-block'>{this.state.message1}</div>}
                    </div>
                    <div className="form-group">
                        <button className="btn btn-primary login-button" id="signIn" title="Sign in button">Sign in</button>
                    </div>
                </form>
                <div className="fineprint" hidden={true}>
                    <p>By continuing, you agree to Phoenix's <strong><a href="/TermsOfService">Terms of Service, Privacy Policy</a></strong></p>
                </div>
                <div>
                    <a href="/Verify" title="Link to register new user">Register New User</a>
                </div>
                <div>
                    <a href="/VerifyReset" title="Link to password reset page">Forgot Username/Password</a>
                </div>
            </div>
        );
    }
}
